import { Link } from 'react-router-dom';
import { Instagram, Facebook, Truck, Clock, CreditCard, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="footer py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 — Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="/bloom-logo.png" 
                alt="Bloom Lingerie" 
                style={{ height: '48px', width: 'auto', maxWidth: '160px', objectFit: 'contain', display: 'block' }}
                data-testid="footer-logo"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Bloom Lingerie habille la femme algérienne avec élégance depuis 2018. 
              Des matières soigneusement sélectionnées, un service irréprochable 
              et le meilleur rapport qualité-prix.
            </p>
          </div>

          {/* Column 2 — Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-gold">Liens Rapides</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-home">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-shop">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/shop?category=bridal" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-bridal">
                  Collection Mariée
                </Link>
              </li>
              <li>
                <Link to="/size-guide" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-sizeguide">
                  Guide des Tailles
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-about">
                  Notre Histoire
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/suivi" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-link-tracking">
                  Suivi de commande
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 — Delivery Info */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-gold">Livraison</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Truck size={18} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Livraison via World Express dans les 58 wilayas d'Algerie</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Délai estimé : 24-48H ouvrables</span>
              </li>
              <li className="flex items-start gap-3">
                <CreditCard size={18} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Paiement à la livraison (COD) disponible</span>
              </li>
            </ul>
          </div>

          {/* Column 4 — Social + WhatsApp */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-gold">Suivez-nous</h4>
            <div className="flex flex-wrap gap-3 mb-6">
              <a 
                href="https://www.instagram.com/bloom_lingerie_m" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-colors"
                data-testid="instagram-link"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="https://www.facebook.com/bloomlingerie.net" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-colors"
                data-testid="facebook-link"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="https://www.tiktok.com/@bloomlingerie" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-colors"
                data-testid="tiktok-link"
                aria-label="TikTok"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13.2a8.16 8.16 0 005.58 2.17v-3.44a4.85 4.85 0 01-3.77-1.47V6.69h3.77z"/>
                </svg>
              </a>
            </div>

            <a
              href="https://wa.me/213782367184?text=Bonjour Bloom Lingerie!"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366]/15 text-[#25D366] px-4 py-2.5 rounded-full text-sm font-medium hover:bg-[#25D366]/25 transition-colors"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle size={16} fill="currentColor" />
              +213 782 36 71 84
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500" data-testid="footer-copyright">
            © 2025 Bloom Lingerie — Alger, Algérie. Tous droits réservés.
          </p>
          <Link to="/politique-confidentialite" className="text-xs text-gray-500 hover:text-white transition-colors" data-testid="privacy-link">
            Politique de confidentialite
          </Link>
          <span className="text-xs text-gray-600">|</span>
          <Link to="/cgv" className="text-xs text-gray-500 hover:text-white transition-colors" data-testid="cgv-link">
            CGV
          </Link>
          <span className="text-xs text-gray-600">|</span>
          <Link to="/mentions-legales" className="text-xs text-gray-500 hover:text-white transition-colors" data-testid="mentions-link">
            Mentions legales
          </Link>
        </div>
      </div>
    </footer>
  );
};
